// extracted by mini-css-extract-plugin
module.exports = {"core":"container-module--core--1y1u5"};